import { Box, Button, TextField, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useAppDispatch, useAppSelector } from "../../redux";
import { AppDispatch } from "../../redux/store";
import { getBreefInviteTracking } from "../../service/BreefInviteService";
import { useNavigate } from "react-router-dom";
import BreefTrackingTable from "./BreefTrackingTable";

export default function BreefTrackingList() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const dispatch: AppDispatch = useAppDispatch();
  const data = useAppSelector((state) => state.breefInvites);
  const navigate = useNavigate();

  const [tenantEmail, setTenantEmail] = useState("");
  const [tenantPhone, setTenantPhone] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({ tenantEmail: "", tenantPhone: "" });

  const fetchTracking = async () => {
    await getBreefInviteTracking(
      dispatch,
      isMobile,
      navigate,
      appliedFilters.tenantEmail,
      appliedFilters.tenantPhone
    );
  };

  useEffect(() => {
    fetchTracking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters]);

  const handleApplyFilters = () => {
    setAppliedFilters({ tenantEmail, tenantPhone });
  };

  const handleClearFilters = () => {
    setTenantEmail("");
    setTenantPhone("");
    setAppliedFilters({ tenantEmail: "", tenantPhone: "" });
  };

  return (
    <Layout>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <h1>Breef SMS/Email Tracking</h1>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexWrap: "wrap",
          margin: "1% auto",
          width: "90%",
        }}
      >
        <TextField
          label="Tenant Email"
          size="small"
          value={tenantEmail}
          onChange={(e) => setTenantEmail(e.target.value)}
        />
        <TextField
          label="Tenant Phone"
          size="small"
          value={tenantPhone}
          onChange={(e) => setTenantPhone(e.target.value)}
        />
        <Button variant="contained" onClick={handleApplyFilters}>
          Filter
        </Button>
        <Button variant="outlined" onClick={handleClearFilters}>
          Clear
        </Button>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <BreefTrackingTable results={data.trackingData.results} />
      </Box>
    </Layout>
  );
}
